<template>
  <div class="row">
    <div class="col-12">
      <div class="card m-b-30">
        <div class="card-header">
          <h5 class="card-title mb-0">Filtri</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <input
                type="text"
                class="form-control"
                placeholder="Nome"
                v-model="query"
              />
            </div>
            <!-- <div class="col-4 ">
               <v-select placeholder="Seleziona banca di riferimento" label="name" :multiple="true"  index="companyId" v-model="selectedCompanies"  :options="cuser.companies"></v-select>
            </div>
            <div class="col-4">
               <v-select placeholder="Seleziona categorie" :multiple=true label="name"  index="templateCategoryId" v-model="selectedCategories"  :options="categories"></v-select>
            </div> -->
          </div>
          <div class="row mt-2">
            <div class="col-12 text-right">
              <button class="btn btn-primary-rgba mr-2" v-on:click="loaddata">
                <i class="feather icon-filter mr-2"></i>Filtra
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <router-link
                class="btn btn-sm btn-primary-rgba"
                :to="{ name: 'route-emailtemplate-edit', id: null }"
              >
                <i class="feather icon-plus"></i> Nuovo template
              </router-link>
              <hr />
              <table
                ref="table"
                id="list-template-table"
                class="table w-100"
              ></table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- /.col -->
  </div>
</template>

<script>
import axios from 'axios'
export default {
  computed: {
    cuser() {
      return this.$store.state.user;
    },
  },
  components: {},
  data() {
    return {
      query: "",
      categories: [],
      companies: [],
      selectedCategories: [],
      selectedCompanies: []
    };
  },
  name: "templatelist",
  beforeMount() {
    var me = this;
    window.ViewMessage = function (id) {
      me.$router.push({
        name: "route-message",
        params: { id: id },
        replace: true,
      });

      return false;
    };
  },

  mounted() {
    setTimeout(this.loaddata, 200);
  },
  methods: {
    edit: function (id) {
      this.$router.push({ name: "route-emailtemplate-edit", params: { id: id } });
      return false;
    },
    loaddata: function () {
      axios.get("templatecategory/list").then((response) => {
        this.categories = response.data;
     
      window["EditAction"] = this.edit;
      var me = this;

      var edit = "M";
      if (me.$refs && me.$refs.edit && me.$refs.edit.outerHTML) {
        edit = me.$refs.edit.outerHTML;
      }

      var remove = "C";
      if (me.$refs && me.$refs.remove && me.$refs.remove.outerHTML) {
        remove = me.$refs.remove.outerHTML;
      }
      if ($.fn.DataTable.isDataTable("#list-template-table")) {
        $("#list-template-table").DataTable().destroy();
      }

      var $table = $("#list-template-table").DataTable({
        processing: true,
        serverSide: true,
         "searching": false,
    "ordering": false,
        ajax: {
          url: window.SETTINGS.apiUrl + "/template/templates",
          type: "POST",
          data: function (d) {
            d.search.value = me.query
            d.filters=[ ];
            return JSON.stringify(d);
          },

          beforeSend: function (request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + me.$store.state.user.token
            );
            request.setRequestHeader("Content-Type", "application/json");
          },
        },

        columns: [
          {
            data: "templateId",
            name: "templateId",
            title: "Categoria",
            render: function (data, type, row, meta) {
              //
              var category = { name:""};
              for (let index = 0; index < me.categories.length; index++) {
                const element = me.categories[index];
                if(element.templateCategoryId == row.templateCategoryId){
                    category.name = element.name;
break;

                }
              }      
                           var retval=`${row.name}`
              return retval;
            },
          },
          {
            className: "text-right",
            data: "templateId",
            name: "templateId",
            title: "Azioni",
            render: function (data, type, row, meta) {
              return `<div class="button-list"><button type="button" class="btn btn-success-rgba" data-id="${data}" onClick="window.EditAction('${data}')"><i class="feather icon-edit-2"></i></button>
                                    <button type="button" class="btn btn-danger-rgba remove-action"  data-id="${data}" data-url="template/${data}"><i class="feather icon-trash"></button></div>`;
            },
          },
        ],
      });
       

      $table.on("select", function (e, dt, type, indexes) {});});
    },
  },
};
</script>
